import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>404 - ページが見つかりません</h1>
      <p>お探しのページは存在しないか、移動された可能性があります。</p>
      <Link to="/" style={{ color: 'blue', textDecoration: 'underline' }}>
        ホームに戻る
      </Link>
    </div>
  );
};

export default NotFoundPage;
